import { CampaignStory, ChatMessageType, CreatePostFormSchema, CreatePostFormType } from '../../types'
import CreateThemeResult from './CreateThemeResult'
import { useState } from 'react'
import CreateThemeForm from './CreateThemeForm'
import ChatCard from '../ChatCard'
import { Button } from '@/shared/ui/button.tsx'
import { Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, useWatch } from 'react-hook-form'

type Props = {
  setStep: (id: ChatMessageType) => void,
  setMessage: (assistant: string, client: string) => void,
  setSelectedTheme: (id: number) => void
}

const CreatePostTheme = ({ setStep, setSelectedTheme }: Props) => {

  const [posts, setPosts] = useState<CampaignStory[]>([])

  const [eventDetails, setEventDetails] = useState<{ event_id: number, event_name: string } | undefined>(undefined)

  const [generateImage, setGenerateImage] = useState(false)

  const [showResult, _] = useState(false)

  const form = useForm<CreatePostFormType>({
    resolver: zodResolver(CreatePostFormSchema),
    defaultValues: {
      activity: "Post"
    }
  })

  const postType: "Post" | "Campaign" = useWatch({
    control: form.control,
    name: "activity"
  })

  const navigate = useNavigate()

  // const setPostHandler = (event_id: number, event_name: string, newPosts: GeneratedSingleThemeType[], result: boolean) => {
  const setPostHandler = (event_id: number, event_name: string) => {
    setEventDetails({ event_id, event_name })
    setSelectedTheme(event_id)
    if (postType === "Campaign") {
      // console.log("show result changed")
      // setShowResult(true)
            navigate(`/home?curr=story&theme=${event_id}`)
    } else {
      navigate(`/home?curr=result&theme=${event_id}`)
    }
  }

  return (
    <>
      <ChatCard user="client">
        <div className="w-full flex flex-col-reverse sm:flex-row justify-between items-end sm:items-center gap-3">

          <div className='flex items-center gap-1'>
            <Button
              onClick={() => setStep("navigation")}
              size="icon"
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              <Home />
            </Button>
            <Button
              onClick={() => setStep("first")}
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              Return to themes
            </Button>
          </div>
          <p className="tracking-wide text-gray-500 font-poppins text-sm">I want to check something new</p>
        </div>
      </ChatCard>
      {showResult && posts.length > 0 && eventDetails ?
        <CreateThemeResult
          event_id={eventDetails.event_id}
          event_name={eventDetails.event_name}
          campaignStories={posts}
        /> :
        <CreateThemeForm
          setCampaignPosts={setPosts}
          createForm={form}
          setPosts={setPostHandler}
          generateImage={generateImage}
          setGenerateImage={setGenerateImage}
        />}
    </>
  )
}

export default CreatePostTheme;
